<!-- 
    PAINEL DE SITUACAO DO CLIENTE
-->

<template>
    <div>
        <bar-manut 
            single-entity="Situação do Cliente" 
            @closeform="closeForm">
        </bar-manut>

        <!-- DADOS DO CLIENTE -->

        <div class="default-container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="lbl-edit w-100">Nome Fantasia</div>
                    <label-title :title="partPainel.fantasia"></label-title>
                </div>
                <div class="col-md-6" v-if="!modal">
                    <v-button class="float-right" label="Alterar Cliente" icon="fa-pencil" :nb-btdef="true" @click="handleEdit"></v-button>
                    <v-button class="float-right" label="Incluir Nova Venda" icon="fa-plus" @click="handleNovaVenda"></v-button>
                </div>
            </div>
            <hr>
            <div class="nb-margin-top pl-5">
                <div class="row col">
                    <div class="lbl w-100">{{ partPainel.nome }}</div>
                    <div class="data-list w-100">{{ partPainel.cnpjcpf | formatCNPJCPF }}</div>
                    <i class="fa fa-location-arrow pr-2"></i>
                    <div class="data-list">{{ partPainel.ende }} {{ partPainel.endenr }} {{ partPainel.endecomp }}</div>
                    <div class="data-list w-100">{{ partPainel.bairro }} - {{ partPainel.mun }} - {{ partPainel.uf }}</div>
                    <div class="data-list w-100">CEP {{ partPainel.cep }}</div>
                </div>
                <div class="row col" v-if="partPainel.contatos && partPainel.contatos.length > 0">
                    <v-label class="w-100" label="Contatos"></v-label>
                </div>
                <div class="row col" v-for="(contato, index) in partPainel.contatos" :key="index">
                    <div class="w-100" v-if="contato.nome">
                        <div class="lbl"><i class="fa fa-user-circle pr-2"></i>{{ contato.nome }}</div>
                    </div>
                    <div class="w-100" v-if="contato.fone1">
                        <i class="fa fa-phone pr-2"></i>
                        <div class="lbl">{{ contato.fone1 | formatFone }}</div>
                    </div>
                    <div class="w-100" v-if="contato.fone2">
                        <i class="fa fa-phone pr-2"></i>
                        <div class="lbl">{{ contato.fone2 | formatFone }}</div>
                    </div>
                    <div class="w-100" v-if="contato.fone3">
                        <i class="fa fa-phone pr-2"></i>
                        <div class="lbl">{{ contato.fone3 | formatFone }}</div>
                    </div>
                    <div class="w-100" v-if="contato.email">
                        <div class="lbl"><i class="fa fa-envelope pr-2"></i> {{ contato.email }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SITUACAO DO CLIENTE -->

        <div class="default-container nb-margin-top">
            <label-title title="Situação do Cliente"></label-title>
            <hr>
            <div class="row pl-5">
                    <div class="col">
                        <v-label class="w-100" label="Limite de Crédito"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.limcred | formatValue(2) }}</div>
                        <v-label class="w-100" label="Títulos Vencidos (-)"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.saldo_titulos_vencido | formatValue(2) }}</div>
                        <v-label class="w-100" label="Títulos à Vencer (-)"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.saldo_titulos_vencer | formatValue(2) }}</div>
                        <v-label class="w-100" label="Pedidos (-)"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.saldo_pedidos | formatValue(2) }}</div>
                        <v-label class="w-100" label="Crédito Disponível"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.saldo_limcred | formatValue(2) }}</div>
                    </div>
                    <div class="col">
                        <v-label class="w-100" label="Última compra"></v-label>
                        <div v-if="!partPainel.dias_ultima_compra" class="nb-dash-total w-100">Nenhuma compra efetuada</div>
                        <div v-if="partPainel.dias_ultima_compra" class="nb-dash-total w-100">{{ partPainel.dias_ultima_compra }} dias sem comprar </div>

                        <v-label class="w-100" label="Valor em Compras"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.valor_comprado | formatValue(2) }}</div>

                        <v-label class="w-100" label="Ticket Médio"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.ticket_medio | formatValue(2) }}</div>

                        <v-label class="w-100" label="Valor em Orçamentos"></v-label>
                        <div class="nb-dash-total w-100">R$ {{ partPainel.valor_orçado | formatValue(2) }}</div>
                    </div>
            </div>
        </div>


        <!-- TITULOS VENCIDOS -->

        <div class="default-container nb-margin-top" style="max-height: 50%">
            <label-title title="Títulos Vencidos"></label-title>
            <hr>
            <div class="w-100 text-center lbl" style="padding: 60px;" v-if="!partPainel.fin_vencido || partPainel.fin_vencido.length == 0">Nenhum dado encontrado</div>

            <div class="row pl-5 nb-margin-bottom" style="overflow: auto" v-for="(fin, index) in partPainel.fin_vencido" :key="index">
                <div class="w-100" style="margin-right: 60px; border-bottom: 1px solid #e7e7e7">
                    <div class="col">
                        <div class="lbl"><i class="fa fa-file-text-o pr-2"></i> {{ fin.doc }}</div>
                    </div>
                    <div class="col">
                        <div class="lbl"><i class="fa fa-calendar pr-2"></i> {{ fin.dtv | formatData }}</div>
                        <div class="lbl">{{ fin.dias }} dia(s)</div>
                    </div>
                    <div class="col">
                        <div class="lbl"><i class="fa fa-dollar pr-2"></i> {{ fin.vlr | formatValue(2) }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- PEDIDOS E ATIVIDADES -->

        <div class="default-container nb-margin-top">
            <label-title title="Últimos Pedidos e Orçamentos"></label-title>
            <div class="lbl-edit w-100">Últimos 6 meses</div>
            <hr>
            <div class="w-100 text-center lbl" style="padding: 60px;" v-if="partPainel.pedidos.length == 0">Nenhum lançamento encontrado</div>
            <div class="row nb-margin-bottom" v-for="(pedido, index) in partPainel.pedidos" :key="index">
                <!-- PEDIDO OU ORÇAMENTO -->
                <div class="float-left">
                    <i class="fa fa-file-text-o icone-pedidos-detalhes"></i>
                </div>
                <div class="w-100" style="margin-left: 90px; margin-right: 60px; border-bottom: 1px solid #e7e7e7">
                    <div class="lbl-title-produto" v-if="pedido.tppedv == 'P'" @click="handleShowPedido">Pedido {{ pedido.npedido }}</div>
                    <div class="lbl-title-produto" v-if="pedido.tppedv != 'P'" @click="handleShowPedido">Orçamento {{ pedido.ncotacao }}</div>
                    <span v-if="pedido.stpedv=='F'" class="badge badge-blue float-right">Faturado</span>
                    <span v-if="pedido.stpedv=='C'" class="badge badge-red float-right">Cancelado</span>
                    <span v-if="pedido.tppedv!='P'" class="badge badge-yellow float-right">Orçamento</span>
                    <div class="data-list w-100">Emitido em: {{ pedido.data | formatData }}</div>
                    <div class="data-list w-100">Criado por: {{ pedido.nome_usuario }}</div>
                    <div class="data-list">R$ {{ pedido.totger | formatValue(2) }}</div>
                </div>
            </div>
        </div>

        <!-- PRODUTOS MAIS COMPRADOS -->

        <div class="default-container nb-margin-top mb-3">
            <label-title title="Produtos Comprados"></label-title>
            <div class="lbl-edit w-100">Últimos 12 meses</div>
            <hr>
            
            <div class="w-100 text-center lbl" style="padding: 60px;" v-if="partPainel.produtos.length == 0">Nenhum produto comprado</div>

            <div class="row" style="padding: 10px" v-for="(produto, index) in partPainel.produtos" :key="index">

                <div class="col-md-6 col-6">
                    <div class="lbl">{{ produto.descricao }}</div>
                </div>
                <div class="col-md-3 col-3">
                    <div class="lbl">Total R$ {{ produto.totliq | formatValue(2) }}</div>
                </div>
                <div class="col-md-3 col-3">
                    <div class="lbl">Quantidade {{ produto.qt }}</div>
                </div>
            </div>
        </div>

        <div class="nb-modal-scrollable" v-if="showPartForm">
            <div class="container nb-modal-scrollable-container" style="width: 800px; max-width: 100%">
                <div class="nb-modal-scrollable-body">
                    <customer-form :crud="crud" :index="codpart" @closeform="closePartForm" :pedidos="appForcaVendas"></customer-form>
                </div>
            </div>
        </div>
     

    </div>

</template>

<script>

import { SysVars } from '../main'
import CustomerForm from '../forms/customer-form'
import { arr } from '../shared/numbers'

export default {
    props: {
        params: {},  //params.codpart
        modal: { Boolean },
    },

    components: {
        CustomerForm
    },

    data() {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            codpart: null,
            showPartForm: false,
            crud: SysVars.crudUpdate,
        }
    },

    computed: {
        partPainel: function () {
            return this.$store.getters.getPartPainel
        },

        appForcaVendas: function () {
            return SysVars.appForcaVendas
        }

    },

    methods: {
        closeForm () {
            if (this.$route.params && this.$route.params.id) {
              this.$router.go(-1)
            } else {
              this.$emit('closeform')
            }
        },

        async loadData () {
            await this.$store.dispatch('loadPartPainel', { id: this.codpart} )
            this.$set(this.partPainel, 'saldo_limcred', 0)
            this.partPainel.saldo_limcred = this.$strToFloat(this.partPainel.limcred,2) - this.$strToFloat(this.partPainel.saldo_pedidos,2) - this.$strToFloat(this.partPainel.saldo_titulos_vencer,2) - this.$strToFloat(this.partPainel.saldo_titulos_vencido,2)
            this.$set(this.partPainel, 'ticket_medio', 0)
            this.partPainel.ticket_medio = arr(this.partPainel.saldo_pedidos / this.partPainel.qt_pedidos, 2)
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        closePartForm () {
            this.showPartForm = false
            this.loadData()
        },

        handleEdit () {
            this.showPartForm = true
        },

        handleNovaVenda () {
            if (SysVars.appForcaVendas)
                this.$router.push('/fv/pedidos/novo/' + this.partPainel.codpart)
            else
                this.$router.push('/pedidos/novo')
        },

        handleShowPedido (codpedv) {
            this.$router.push('/fv/pedidos/' + codpedv)
        },

    },

    beforeCreate () {

    },

    created () {
        console.log(this.params)
        if (this.$route.params && this.$route.params.id) {
            this.codpart = this.$route.params.id
        } else {
            this.codpart = this.params.codpart
        }
        this.loadData()
    }

}

</script>

<style>

.icone-pedidos-detalhes {
    font-size: 35px; 
    position: absolute; 
    padding: 30px; 
    color: rgb(167, 169, 170);
}

</style>



// WEBPACK FOOTER //
// src/forms/customer-painel-form.vue